document.addEventListener('DOMContentLoaded', () => {
	const triggers = Array.from(document.querySelectorAll('.js-lightbox'));
	if (!triggers.length) return;

	const overlay = document.createElement('div');
	overlay.className = 'lightbox-overlay';
	overlay.innerHTML = `
		<button type="button" class="lightbox-close" aria-label="閉じる"></button>
		<button type="button" class="lightbox-arrow lightbox-prev" aria-label="前の画像"></button>
		<img class="lightbox-image" src="" alt="">
		<button type="button" class="lightbox-arrow lightbox-next" aria-label="次の画像"></button>
	`;
	document.body.appendChild(overlay);

	const imgEl = overlay.querySelector('.lightbox-image');
	const closeBtn = overlay.querySelector('.lightbox-close');
	const prevBtn = overlay.querySelector('.lightbox-prev');
	const nextBtn = overlay.querySelector('.lightbox-next');

	const groups = {};
	triggers.forEach((trigger) => {
		const group = trigger.dataset.group || 'default';
		if (!groups[group]) groups[group] = [];
		groups[group].push(trigger);
	});

	let currentGroup = [];
	let currentIndex = 0;

	const updateArrows = () => {
		const hasMultiple = currentGroup.length > 1;
		prevBtn.style.display = hasMultiple ? '' : 'none';
		nextBtn.style.display = hasMultiple ? '' : 'none';
	};

	const show = (index) => {
		currentIndex = (index + currentGroup.length) % currentGroup.length;
		const trigger = currentGroup[currentIndex];
		imgEl.src = trigger.getAttribute('href');
		imgEl.alt = trigger.querySelector('img') ? trigger.querySelector('img').alt : '';
	};

	const open = (trigger) => {
		const group = trigger.dataset.group || 'default';
		currentGroup = groups[group];
		updateArrows();
		show(currentGroup.indexOf(trigger));
		overlay.classList.add('is-active');
		document.body.classList.add('is-lightbox-open');
	};

	const close = () => {
		overlay.classList.remove('is-active');
		document.body.classList.remove('is-lightbox-open');
		imgEl.src = '';
	};

	triggers.forEach((trigger) => {
		trigger.addEventListener('click', (e) => {
			e.preventDefault();
			open(trigger);
		});
	});

	closeBtn.addEventListener('click', close);
	overlay.addEventListener('click', (e) => {
		if (e.target === overlay) close();
	});
	prevBtn.addEventListener('click', () => show(currentIndex - 1));
	nextBtn.addEventListener('click', () => show(currentIndex + 1));

	document.addEventListener('keydown', (e) => {
		if (!overlay.classList.contains('is-active')) return;
		if (e.key === 'Escape') close();
		if (e.key === 'ArrowLeft') show(currentIndex - 1);
		if (e.key === 'ArrowRight') show(currentIndex + 1);
	});

	let touchStartX = 0;
	const swipeThreshold = 50;

	overlay.addEventListener('touchstart', (e) => {
		touchStartX = e.changedTouches[0].screenX;
	}, { passive: true });

	overlay.addEventListener('touchend', (e) => {
		const diff = e.changedTouches[0].screenX - touchStartX;
		if (Math.abs(diff) < swipeThreshold) return;
		diff > 0 ? show(currentIndex - 1) : show(currentIndex + 1);
	}, { passive: true });
});
